import React, { useRef, useState, useEffect } from "react";
import AnimateHeight from "react-animate-height";

import Localization from "../../../localization";
import { fixExternalLinks } from "../../../utils/helper";

const AccordionDescription = ({ locale, id, description }) => {
    const [open, setOpen] = useState(false);
    const [divHeight, setDivHeight] = useState(0);
    const ref = useRef(null);

    let height = divHeight > 0 ? Math.min(divHeight, 80) : 80;
    let textButton = Localization[locale].classes.see_more;

    const _onPress = () => {
        setOpen(!open);
    };

    useEffect(() => {
        setDivHeight(ref.current.clientHeight);
    });

    useEffect(() => {
        setOpen(false);
    }, [id]);

    if (open) {
        height = "auto";
        textButton = Localization[locale].classes.see_less;
    }

    return (
        <div className="mt-30" id={id} key={id}>
            <AnimateHeight id={id} duration={300} height={height}>
                <div
                    ref={ref}
                    className="article-body"
                    dangerouslySetInnerHTML={{
                        __html: fixExternalLinks(description),
                    }}
                />
            </AnimateHeight>
            {divHeight > 80 && (
                <div
                    className="mt-12"
                    aria-expanded={height !== 0}
                    aria-controls={id}
                    onClick={_onPress}
                >
                    <p className="underline cursor-pointer">{textButton}</p>
                </div>
            )}
        </div>
    );
};

export default AccordionDescription;
